import type { MailboxInfo } from 'owa-client-types';
import copilotSettingsStore from '../store/store';

export function getManifestIdForAddin(titleId: string, mailboxInfo: MailboxInfo) {
    const store = copilotSettingsStore(mailboxInfo);
    return store.extensibility.addinInfoById.get(titleId)?.manifestId;
}
